import React from 'react'
import useMediaQuery from '@mui/material/useMediaQuery'
import TimedToastAlert from '../../components/alerts/TimedToastAlert'
import { layoutMobileMediaQuery } from '../../layout/layoutConstants'
import LoginBrandArt from './LoginBrandArt'
import { LOGIN_BRAND_FEATURES } from './loginConstants'

export default function LoginShell({
  eyebrow,
  title,
  subtitle,
  children,
  alertId,
  toastAlertMessage,
  toastAlertSeverity = 'error',
  onClearToast
}) {
  const isMobileLayout = useMediaQuery(layoutMobileMediaQuery)

  const toast = toastAlertMessage ? (
    <TimedToastAlert
      id={alertId}
      variant="toast"
      severity={toastAlertSeverity}
      message={toastAlertMessage}
      onClose={onClearToast}
    />
  ) : null

  const brandPanel = (
    <aside
      className={`login-brand-panel${isMobileLayout ? ' login-brand-panel-mobile' : ''}`}
      aria-label="Ubiqua"
    >
      <LoginBrandArt className={isMobileLayout ? 'login-tower-mobile' : ''} />

      <div className="login-brand-top">
        <div className="login-brand-logo login-enter login-enter-1">
          <img src="/ubiqua_logo_white.png" alt="Ubiqua" />
        </div>

        <p className="login-eyebrow login-brand-badge login-enter login-enter-2">
          Torre de Control
        </p>
        <h1 className="login-brand-headline login-enter login-enter-3">
          {isMobileLayout ? (
            <>
              Tu operación comercial <b>en un solo lugar.</b>
            </>
          ) : (
            <>
              Toda tu operación comercial, <b>en un solo lugar.</b>
            </>
          )}
        </h1>

        {isMobileLayout ? null : (
          <ul className="login-brand-features">
            {LOGIN_BRAND_FEATURES.map((feature, index) => {
              const Icon = feature.Icon
              return (
                <li
                  key={feature.text}
                  className={`login-brand-feature login-enter login-enter-${index + 4}`}
                >
                  <span className="login-brand-feature-icon" aria-hidden="true">
                    <Icon size={18} weight="bold" />
                  </span>
                  <span className="login-brand-feature-text">{feature.text}</span>
                </li>
              )
            })}
          </ul>
        )}
      </div>

      {isMobileLayout ? null : (
        <p className="login-brand-footer">
          © {new Date().getFullYear()} Ubiqua. Todos los derechos reservados.
        </p>
      )}
    </aside>
  )

  const formPanel = (
    <main className={`login-form-panel${isMobileLayout ? ' login-form-panel-mobile' : ''}`}>
      <div className="login-form-wrap login-enter login-enter-form">
        <div className="login-form-header">
          {eyebrow ? <p className="login-eyebrow">{eyebrow}</p> : null}
          <h2>{title}</h2>
          {subtitle ? <p>{subtitle}</p> : null}
        </div>
        {children}
      </div>
    </main>
  )

  if (isMobileLayout) {
    return (
      <div className="login-page login-page-main login-page-mobile">
        {toast}
        {brandPanel}
        <div className="login-mobile-body">
          <section className="login-mobile-sheet">{formPanel}</section>
        </div>
      </div>
    )
  }

  return (
    <div className="login-page login-page-main login-page-desktop">
      {toast}
      {brandPanel}
      {formPanel}
    </div>
  )
}
